import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Input, Button, Form, Menu} from 'ant-design-vue';

import './assets/style/ant.scss'
import './assets/style/common.scss'


Vue.config.productionTip = false

Vue.component(Input.name, Input)
Vue.component(Button.name, Button)
Vue.component(Form.name, Form)
Vue.component(Form.Item.name, Form.Item)
Vue.component(Menu.name, Menu)
Vue.component(Menu.Item.name, Menu.Item)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
